import { medicalActions } from '../actionType';

export const medicalReducer = (state, action) => {
    switch (action.type) {
        case medicalActions.SAVE_SELECT_BTN: {
            return {
                selectBtn: action.payload
            }
        }
        default:
            return state;
    }
}